"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeId = void 0;
const crypto = __importStar(require("crypto"));
const viem_1 = require("viem");
/**
 * Generates a new random BigInt based ID (32 bytes / 256 bits).
 *
 * This function ensures consistent hexadecimal representation of the generated ID,
 * addressing the issue described in MJ-471 (https://moojo.atlassian.net/browse/MJ-471).
 *
 * The process involves multiple transformations:
 * 1. Generate 32 random bytes
 * 2. Convert to hexadecimal string
 * 3. Parse as BigInt
 * 4. Convert back to hexadecimal
 *
 * This approach guarantees:
 * - Total length of 65 or 66 characters, including '0x' prefix
 * - Proper zero-padding for values with leading zero bytes (after '0x' prefix)
 *
 * Reminder: The output may be 65 or 66 characters long (including '0x' prefix).
 * - 65 characters when the most significant bit is 0 (value < 2^255)
 * - 66 characters when the most significant bit is 1 (value >= 2^255)
 */
const makeId = () => (0, viem_1.toHex)((0, viem_1.fromHex)((0, viem_1.toHex)(crypto.randomBytes(32)), 'bigint'));
exports.makeId = makeId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFrZS1pZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tYWtlLWlkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0EsK0NBQWdDO0FBQ2hDLCtCQUFxQztBQUVyQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQW1CRztBQUNJLE1BQU0sTUFBTSxHQUFHLEdBQTBCLEVBQUUsQ0FBQyxJQUFBLFlBQUssRUFBQyxJQUFBLGNBQU8sRUFBQyxJQUFBLFlBQUssRUFBQyxNQUFNLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQTtBQUE3RixRQUFBLE1BQU0sVUFBdUYifQ==